import http from "../config/httpConfig";

export default async ({ path, method, data, options }) => {
  try {
    let response;
    switch (method) {
      case "PATCH":
        response = await http.patch(path, data, {
          ...options,
        });
        return response.data;
      case "GET":
        response = await http.get(path, {
          ...options,
        });
        return response.data;
      case "POST":
        response = await http.post(path, data, {
          ...options,
        });
        return response.data;
      case "DELETE":
        response = await http.delete(path, {
          ...options,
        });
        return response.data;
      default:
        break;
    }
  } catch (error) {
    return {
      error: true,
      status:
        error.response && error.response.data && error.response.data.status,
      message:
        error.message && error.message.includes("Network Error")
          ? "Connection failed, please check internet connection or contact administrator"
          : error.response.data.message || error.response.data,
    };
  }
};
